<template>
  <Home :viewModel="viewModel" />
</template>

<script>
import Home from './components/HomeComponentDesktop.vue';
export default {
  components: {
    Home
  },
  props: {
    viewModel: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>


